import classNames from "classnames";
import type { SliderRecommendations } from "@/types/slider.types";
import { Slider } from "@/components/shared/data-display/slider/slider";
import styles from "./work-slider.module.scss";
import {
  trackRecommendationsShown,
  trackStructuredSnowplowEvent,
} from "@/utility/analytics.utility";

interface WorkSliderProps {
  slider?: SliderRecommendations;
  compact?: boolean;
  hasBackground?: boolean;
}

const WorkSlider = ({
  slider,
  compact = false,
  hasBackground = false,
}: WorkSliderProps) => {
  if (!slider?.items.length) return null;

  return (
    <section
      className={classNames(styles.root, {
        [styles.hasBackground]: hasBackground,
      })}
      aria-label={slider.title ?? "Book recommendations"}
    >
      <Slider
        variant="legacy"
        compact={compact}
        title={slider.title}
        description={slider.subtitle}
        flag={slider.bannerText}
        url={slider.url}
        guidUserRecommendation={slider.guidUserRecommendation}
        items={slider.items}
        onSliderShown={() => {
          void trackRecommendationsShown(slider);
        }}
        onItemClick={(idWork, position) => {
          void trackStructuredSnowplowEvent(
            "Recommendation",
            "clicked",
            slider.identifier,
            idWork.toString(),
            position,
          );
        }}
      />
    </section>
  );
};

export default WorkSlider;
